import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ReportesLibranzasComponent } from '../reportes-libranzas/reportes-libranzas.component';

@Component({
    selector: "app-libranza-actual",
    templateUrl: "./libranza-actual.component.html",
    styleUrls: ["./libranza-actual.component.css"],
})
export class LibranzaActualComponent implements OnInit {
    url: SafeResourceUrl = "";
    isLoading: boolean = false;
    loadMsj: string = "";
    items: any[] = [];
    username: string = '';
    baseDomain: string;
    defaultUrl: SafeResourceUrl;

    ngOnInit() {
        const user = JSON.parse(sessionStorage.getItem("user"));
        console.log(environment.clientType)
        this.username = user.username || user; // Manejo flexible del username
        // Determinar el dominio base según el clientType
        switch (environment.clientType) {
            case 'cafam':
                this.baseDomain = 'devcafam.datascoring.co';
                break;
            case 'cafamQA':
                this.baseDomain = 'qacafamaws.datascoring.co';
                break;
            case 'cafamPROD':
                this.baseDomain = 'prdcafam.datascoring.co';
                break;
            default:
                this.baseDomain = 'devcafam.datascoring.co'; // Fallback a desarrollo
                break;
        }
        
        // Crear la URL por defecto sanitizada
        this.defaultUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://${this.baseDomain}/QALI/default.aspx?sUsuario=${this.username}&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys`
        );
        
        this.initializeMenu();
    }

    private buildUrl(path: string): string {
        return `https://${this.baseDomain}${path}`;
    }

    private initializeMenu() {
        this.items = [
            {
                label: 'Pre-Libranza',
                permissionCode: 'P700B0000',
                items: [
                    {
                        label: 'Generar Pre-Libranza',
                        permissionCode: 'P700B0001',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANRES&IdClient=0&IdRef=0&sUsuario=${this.username}&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Cargue Planilla Individual',
                        permissionCode: 'P700B0002',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANSP2&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    }
                ]
            },
            {
                label: 'Conciliaciones',
                permissionCode: 'P700B0041',
                items: [
                    {
                        label: 'ABC Depósitos',
                        permissionCode: 'P700B0003',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qLibranzas/wfmDepositos.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Conciliar',
                        permissionCode: 'P700B0004',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANRLI&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Conciliar por Librador',
                        permissionCode: 'P700B0005',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qLibranzas/wfmConciliaciones.aspx?Modal=MENU&sPantalla=PANLIB&IdClient=0&IdRef=0&sUsuario=${this.username}&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Asignar Depósitos',
                        permissionCode: 'P700B0006',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANDEP&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Asignar Códigos SAP',
                        permissionCode: 'P700B0007',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANSAP&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Asignar Códigos SAP Por Fecha',
                        permissionCode: 'P700B0008',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANSP1&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Genera Interface Contable',
                        permissionCode: 'P700B0009',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=PANCONT&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    }
                ]
            },
            {
                label: 'Gestión de Cobranza',
                permissionCode: 'P700B0042',
                items: [
                    {
                        label: 'Gestionar libradores',
                        permissionCode: 'P700B0010',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qReports/wfmReportViewer.aspx?modal=MENU&sReporte=CF01&iAccion=2&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Agendar seguimiento',
                        permissionCode: 'P700B0011',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=LIBAGE&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    }
                ]
            },
            {
                label: 'Tableros Control',
                permissionCode: 'P700B0043',
                items: [
                    {
                        label: 'Concentración Pagadurías',
                        permissionCode: 'P700B0012',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=ByPag&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }

                    },
                    {
                        label: 'Colocación',
                        permissionCode: 'P700B0013',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=pancolo&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }

                    },
                    {
                        label: 'Recaudo',
                        permissionCode: 'P700B0014',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=DBPAGOS&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    }
                ]
            },
            {
                label: 'Venta Cartera',
                permissionCode: 'P700B0044',
                items: [
                    {
                        label: 'Preselección Portafolio',
                        permissionCode: 'P700B0015',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                ``
                            );
                        }
                    },
                    {
                        label: 'Genera Pre-venta',
                        permissionCode: 'P700B0016',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                ``
                            );
                        }
                    },
                    {
                        label: 'Cargue Venta',
                        permissionCode: 'P700B0017',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                ``
                            );
                        }
                    }
                ]
            },
            {
                label: 'SIG',
                permissionCode: 'P700B0045',
                items: [
                    {
                        label: 'Empresas y Afiliados',
                        permissionCode: 'P700B0018',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=LIBEYA&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Perfiles',
                        permissionCode: 'P700B0019',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=DBApps&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Colocaciones',
                        permissionCode: 'P700B0020',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=DBColo&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Árbol Segmentación',
                        permissionCode: 'P700B0021',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qCommon/wfmVarManager.aspx?modal=MENU&idAccion=4&sPantalla=DBArbol&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                ]
            },
            {
                label: 'Cartera',
                permissionCode: 'P700B0046',
                items: [
                    {
                        label: 'ABC Castigos',
                        permissionCode: 'P700B0022',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qLibranzas/wfmCastigos.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                            );
                        }
                    },
                    {
                        label: 'Contabilidad',
                        permissionCode: 'P700B0049',
                        items: [
                            {
                                label: 'ABC Promociones',
                                permissionCode: 'P700B0023',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qInterfacesSAP/wfmBusquedaPromociones.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            },
                            {
                                label: 'ABC Cuentas',
                                permissionCode: 'P700B0024',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qInterfacesSAP/wfmParametrizacionCuentas.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            }
                        ]
                    },
                    {
                        label: 'Ajustes OP',
                        permissionCode: 'P700B0050',
                        items: [
                            {
                                label: 'Ajustes Manuales',
                                permissionCode: 'P700B0025',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qInterfacesSAP/wfmAjustesOPBusqueda.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            },
                            {
                                label: 'Ajustes Masivos',
                                permissionCode: 'P700B0026',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qInterfacesSAP/wfmAjustesOPImportar.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            }
                        ]
                    },
                    {
                        label: 'Tasas Niif',
                        permissionCode: 'P700B0051',
                        items: [
                            {
                                label: 'ABC Tasas Niif',
                                permissionCode: 'P700B0027',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qLibranzas/wfmTasasNiifLista.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            },
                            {
                                label: 'ABC Tasas Homologación',
                                permissionCode: 'P700B0028',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qLibranzas/wfmTasasHomolLista.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            },
                            {
                                label: 'ABC Lineas Mercado',
                                permissionCode: 'P700B0029',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qLibranzas/wfmLineasMercado.aspx?modal=MENU&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            }
                        ]
                    }
                ]
            },
            {
                label: 'Reportes',
                permissionCode: 'P700B0047',
                items: [
                    {
                        label: 'Conciliación',
                        permissionCode: 'P700B0052',
                        items: [
                            {
                                label: 'Pagos Individuales',
                                permissionCode: 'P700B0030',
                                reportId: 'CF03',
                                command: () => {
                                    const item = {
                                        reportId: 'CF03'
                                    };
                                    this.openReportsDialog(item);
                                }
                            }
                        ]
                    },
                    {
                        label: 'Libranza',
                        permissionCode: 'P700B0053',
                        items: [
                            {
                                label: 'Recaudo Banco',
                                permissionCode: 'P700B0031',
                                command: () => {
                                    const item = {
                                        reportId: 'LB10'
                                    };
                                    this.openReportsDialog(item);
                                }
                            },
                            {
                                label: 'Partidas Conciliatorias',
                                permissionCode: 'P700B0032',
                                command: () => {
                                    const item = {
                                        reportId: 'LB13'
                                    };
                                    this.openReportsDialog(item);
                                }
                            },
                            {
                                label: 'Partidas Sin Conciliar',
                                permissionCode: 'P700B0033',
                                command: () => {
                                    const item = {
                                        reportId: 'LB11'
                                    };
                                    this.openReportsDialog(item);
                                }
                            },
                            {
                                label: 'Deposito Ajuste',
                                permissionCode: 'P700B0034',
                                command: () => {
                                    const item = {
                                        reportId: 'LB12'
                                    };
                                    this.openReportsDialog(item);
                                }
                            },
                            {
                                label: 'Estado Deposito',
                                permissionCode: 'P700B0035',
                                command: () => {
                                    const item = {
                                        reportId: 'LB14'
                                    };
                                    this.openReportsDialog(item);
                                }
                            },
                            {
                                label: 'LogTS',
                                permissionCode: 'P700B0036',
                                command: () => {
                                    const item = {
                                        reportId: 'CF05'
                                    };
                                    this.openReportsDialog(item);
                                }
                            }
                        ]
                    },
                    {
                        label: 'Cartera',
                        permissionCode: 'P700B0054',
                        items: [
                            {
                                label: 'Castigos',
                                permissionCode: 'P700B0037',
                                command: () => {
                                    const item = {
                                        reportId: 'CF04'
                                    };
                                    this.openReportsDialog(item);
                                }
                            }
                        ]
                    }
                ]
            },
            {
                label: 'Seguridad',
                permissionCode: 'P700B0048',
                items: [
                    {
                        label: 'Administrador',
                        permissionCode: 'P700B0039',
                        command: () => {
                            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                this.buildUrl(`/QALI/qSecurity/wfmSeguridad.aspx`)
                            );
                        }
                    },
                    {
                        label: 'Reportes',
                        permissionCode: 'P700B0055',
                        items: [
                            {
                                label: 'Usuarios',
                                permissionCode: 'P700B0040',
                                command: () => {
                                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                                        this.buildUrl(`/QALI/qReports/wfmReportViewer.aspx?modal=MENU&sReporte=CF06&iAccion=2&IdClient=0&IdRef=0&sUsuario=OROJAS&sEmpresa=CAFA&sIdioma=0&sPerfil=Credisys#`)
                                    );
                                }
                            }
                        ]
                    }
                ]
            }
        ];
    }

    constructor(
        private sanitizer: DomSanitizer,
        private dialog: MatDialog
    ) { }

    navigateTo(item: any): void {
        if (item.command) {
            item.command();
        }
    }

    checkSubmenuPosition(event: MouseEvent, subItem: any) {
        setTimeout(() => {
            const li = (event.target as HTMLElement).closest('li');
            if (!li) return;
            const submenu = li.querySelector('ul');
            if (submenu) {
                const rect = submenu.getBoundingClientRect();
                const margin = 40; // margen de seguridad mayor
                // Si el submenú se sale por la derecha o no cabe completamente, abrir a la izquierda
                subItem.openLeft = (rect.right > window.innerWidth - margin) && (rect.left > rect.width);
            }
        }, 0);
    }

    openReportsDialog(item: any): void {
        const dialogRef = this.dialog.open(ReportesLibranzasComponent, {
            width: '80%',
            maxWidth: '1200px',
            data: {
                reportId: item.reportId
            }
        });
    }
}
